import React from 'react';
import { Link } from 'gatsby';
import colors from '../../../../../tailwind.colors';
import { Typography } from '../../../atoms/typography/Typography';
import { Arrow } from '../../../../../static/icons/arrow';
import { Stack } from '../../../atoms/stack/Stack';
import { Row } from '../../../atoms/row/Row';

import { StyledHtmlDiv } from '../../../atoms/styledHtmlDiv/StyledHtmlDiv';

const NextArticle = ({ data }) => (
  <Link
    to={data.href}
    className="flex w-full flex-1 bg-primary-50 my-12 py-12 px-8 global-hover"
  >
    <div className="flex flex-col md:flex-row flex-1 gap-5 justify-between items-start md:items-center mx-auto max-w-3xl">
      {data.articleImg && (
        <img
          className="rounded-lg w-auto object-contain max-h-[150px]"
          src={data.articleImg}
          alt={data.title}
          loading="lazy"
        />
      )}
      <Row className="h-full justify-between items-center gap-3">
        <Stack className="justify-between h-full gap-3">
          <Stack className="gap-3">
            <Typography
              as="h3"
              textAlign="left"
              className="font-medium leading-none"
              fontVariant="h6"
            >
              {data.title}
            </Typography>
            <Typography textAlign="left" className="font-light leading-none">
              <StyledHtmlDiv content={data.introText} />
            </Typography>
          </Stack>
          <div className="flex flex-wrap gap-1">
            {data.categories.map((cat, i) => (
              <Typography
                key={i}
                fontVariant="sm"
                className="bg-customGray-200 rounded-lg py-1 px-2"
              >
                {cat}
              </Typography>
            ))}
          </div>
        </Stack>
        <span>
          <Arrow
            color={colors.customGray[900]}
            direction="right"
            height={40}
            width={40}
          />
        </span>
      </Row>
    </div>
  </Link>
);

export default NextArticle;
